import { httpPostToken } from "@/api/httpService";
import { loginOrRegisterMapping } from "@/api/authApi";
import { getRuntimeConfig } from "@/core/runtimeConfig";
import {
  clearAuthCookies,
  isLoggedIn,
  parseUserInfoCookie,
  writeUserInfoCookie,
} from "@/core/auth/token";
import { resetLoginSyncFlag } from "@/core/auth/synchronizeUserPermission";

const USER_DISABLED_CODE = 10005;

// 免登录同步机制已停用，保留原代码便于回溯。
// function syncRingFreeLogin() {
//   const iframe = document.createElement("iframe");
//   iframe.style.display = "none";
//   iframe.src = "https://www.ringdata.com/freeLogin";
//   document.body.appendChild(iframe);
//   window.setTimeout(() => {
//     document.body.removeChild(iframe);
//   }, 3000);
// }

const authModule = {
  namespaced: true,
  state: {
    localUser: null,
    isAdmin: false,
    loginReady: false,
  },
  mutations: {
    setAuth(state, { localUser, isAdmin }) {
      state.localUser = localUser;
      state.isAdmin = !!isAdmin;
    },
    clearAuth(state) {
      state.localUser = null;
      state.isAdmin = false;
    },
    setLoginReady(state, ready) {
      state.loginReady = ready;
    },
  },
  actions: {
    clearAuth({ commit, state }) {
      const userId =
        state.localUser?.id ?? parseUserInfoCookie()?.userId ?? null;
      resetLoginSyncFlag(userId);
      clearAuthCookies();
      commit("clearAuth");
    },
    async loginWithOAuth({ commit, dispatch }, credentials) {
      const { loginName, password } = credentials;
      const cfg = getRuntimeConfig();
      const clientType = cfg.LOGIN_SSO_CLIENT_TYPE || "OPEN";
      const ip = window.localStorage.getItem("ip") || "";
      const city = window.localStorage.getItem("city") || "";

      const tokenRes = await httpPostToken(
        "/oauth/token",
        `grant_type=password&username=${encodeURIComponent(
          loginName
        )}&password=${encodeURIComponent(
          password
        )}&clientType=${clientType}&ip=${encodeURIComponent(
          ip
        )}&city=${encodeURIComponent(city)}`
      );
      if (!tokenRes || tokenRes.code !== 0) {
        return tokenRes;
      }

      // syncRingFreeLogin();

      const mapRes = await loginOrRegisterMapping();
      if (mapRes && mapRes.code === 0 && mapRes.data) {
        if (mapRes.data.user) {
          writeUserInfoCookie({
            ...parseUserInfoCookie(),
            ...mapRes.data.user,
            userId: mapRes.data.user.id,
          });
        }
        commit("setAuth", {
          localUser: mapRes.data.user,
          isAdmin: mapRes.data.isAdmin,
        });
        commit("setLoginReady", true);
        await dispatch("permission/fetchPermission", null, { root: true });
        return mapRes;
      }

      if (mapRes && mapRes.code === USER_DISABLED_CODE) {
        await dispatch("clearAuth");
      }
      return mapRes;
    },
    async restoreSession({ commit, dispatch, state }) {
      if (!isLoggedIn()) {
        commit("clearAuth");
        commit("setLoginReady", true);
        return;
      }

      const cookieUser = parseUserInfoCookie();
      if (cookieUser && !state.localUser) {
        commit("setAuth", {
          localUser: {
            id: cookieUser.userId ?? cookieUser.id,
            name: cookieUser.name ?? cookieUser.loginName,
          },
          isAdmin: false,
        });
      }

      await dispatch("permission/fetchPermission", null, { root: true });
      commit("setLoginReady", true);
    },
  },
};

export default authModule;
